import { THREE } from "@scrolly/renderer";

class VideoMaterial {
    material: THREE.ShaderMaterial;
    videoPlayer: HTMLVideoElement;
    videoImage: HTMLCanvasElement;
    videoImageContext: CanvasRenderingContext2D;
    texture: THREE.Texture;
    chromaKey: THREE.Color;
    transparency = true;

    constructor(
        videoPlayer: HTMLVideoElement,
        videoParams: {
            chromaKey: THREE.Color;
            transparent: boolean;
            tolerance: number;
        }
    ) {
        this.videoPlayer = videoPlayer;
        this.videoImage = document.createElement("canvas");
        this.videoImage.width = videoPlayer.videoWidth;
        this.videoImage.height = videoPlayer.videoHeight;

        this.videoImageContext = this.videoImage.getContext("2d")!;

        this.videoImageContext.fillStyle = "#FFFFFF";
        this.videoImageContext.fillRect(0, 0, this.videoImage.width, this.videoImage.height);

        this.texture = new THREE.Texture(this.videoImage);
        this.texture.minFilter = THREE.LinearFilter;
        this.texture.magFilter = THREE.LinearFilter;
        this.texture.wrapS = THREE.RepeatWrapping;
        this.texture.repeat.x = -1;

        this.chromaKey = new THREE.Color(videoParams.chromaKey || new THREE.Color(0x000000));
        const tolerance = videoParams.tolerance === undefined ? 10 : videoParams.tolerance;

        const uniforms = {
            videoTexture: { type: "t", value: this.texture },
            transparent: { type: "f", value: 0.0 },
            color: { type: "c", value: this.chromaKey },
            tolerance: { type: "f", value: tolerance },
            opacity: { type: "f", value: 1 },
        };

        if (videoParams.transparent) {
            uniforms.transparent = { type: "f", value: 1.0 };
        }

        this.material = new THREE.ShaderMaterial({
            uniforms,
            transparent: true,
            vertexShader: `

            varying vec2 vUv;

            void main() {
                vUv = uv;
                gl_PointSize = 8.0;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }

          `,
            fragmentShader: `

            varying vec2 vUv;
            uniform float opacity;
            uniform sampler2D videoTexture;
            uniform vec3 color;
            uniform float tolerance;
            uniform float transparent;

            void main() {

                vec3 video  = texture2D(videoTexture, vUv).rgb;
                // Franks version
                float a = 1.0;
                // if( key == 1.0 ) {

                //     if(( video.r + video.b) < video.g  ){

                //          video = color;
                //          if( transparent == 1.0 ) {
                //            a = 0.0;
                //          }

                //     }

                // }
                // https://makc3d.wordpress.com/2014/04/01/transparent-video-texture-in-three-js/
                // float a = (0.9 - dot(color, video) / (length(video) + 0.05)) * 3.0;
                if (transparent == 1.0) {
                  // tolerance should be something like 10.0
                  a = min((length(video - color) - 0.5) * tolerance, 1.0);
                }
                gl_FragColor = vec4(video, a * opacity);

            }

          `,
        });

        this.material.uniforms.videoTexture.value.wrapS = THREE.ClampToEdgeWrapping;
        this.material.uniforms.videoTexture.value.wrapT = THREE.ClampToEdgeWrapping;

        // const videoGeometry = new THREE.PlaneBufferGeometry(20, 5, 32);
        // const videoMesh = new THREE.Mesh(videoGeometry, this.material);

        // videoMesh.position.y += 10;
        // videoMesh.scale.set(5, 5, 5);
    }

    update() {
        if (this.videoPlayer.readyState === this.videoPlayer.HAVE_ENOUGH_DATA) {
            this.videoImageContext.drawImage(this.videoPlayer, 0, 0);

            if (this.texture) {
                this.texture.needsUpdate = true;
                this.material.uniforms.videoTexture.value = this.texture;
            }
        }
    }
}

export default VideoMaterial;
